
import { SistemaMixin } from "@/modules/Application";
import TableApp from "@/components/Table/Table2";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import Pencil from "vue-material-design-icons/Pencil.vue";
import Magnify from "vue-material-design-icons/Magnify.vue";
import Send from "vue-material-design-icons/Send.vue";
import Cancel from "vue-material-design-icons/FileCancel.vue";
import swal from "sweetalert";
import { actionsStore } from "@/components/Table/actionsStore";
import PdfIcon from "vue-material-design-icons/FilePdfBox.vue";
import FilterFields from "@/components/FilterFields";
import Menu from "vue-material-design-icons/Menu";
import Mail from "vue-material-design-icons/Email";
import SendToWppModal from "@/components/SendToWppModal";
import Whatsapp from "vue-material-design-icons/Whatsapp.vue";
import XMLIcon from "vue-material-design-icons/FileDocument";
import ContentCopy from "vue-material-design-icons/ContentCopy.vue";

export default {
  name: "servicosNFse",
  mixins: [SistemaMixin],
  components: {
    TableApp,
    TrashCanIcon,
    Pencil,
    Magnify,
    Send,
    Cancel,
    PdfIcon,
    FilterFields,
    Menu,
    SendToWppModal,
    Whatsapp,
    Mail,
    XMLIcon,
    ContentCopy,
  },
  data() {
    return {
      actionsStore,
      dataToWhatsapp: null,
      jsonTecnoSpeedAberto: false,
      jsonTecnoSpeed: { id_nfse: null, conteudo: "", salvando: false },
      fields: [
        {
          label: "Número",
          field: "numero",
          slot: true,
          sortable: false,
        },
        {
          label: "Cliente",
          field: "cliente",
          type: "text",
          slot: true,
          sortable: false,
        },
        {
          label: "Data de Emissao",
          field: "emissao",
          slot: true,
          sortable: false,
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "dd/MM/yyyy",
        },
        {
          label: "Data de Autorização",
          field: "autorizacao",
          slot: true,
          sortable: false,
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "dd/MM/yyyy",
        },
        {
          label: "Status",
          field: "status",
          slot: true,
          sortable: false,
        },
        {
          label: "Total",
          field: "total_nfse",
          slot: true,
          sortable: false,
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          width: "5%",
          slot: true,
        },
      ],
    };
  },
  created() {},
  methods: {
    abrirJsonTecnoSpeed({ id_nfse, status, data_tecnospeed }) {
      if (![2, 5].includes(status) || this.jsonTecnoSpeed.salvando) return;

      const conteudo =
        typeof data_tecnospeed === "string"
          ? data_tecnospeed
          : data_tecnospeed
          ? JSON.stringify(data_tecnospeed, null, 2)
          : "";
      this.jsonTecnoSpeed = { id_nfse, conteudo, salvando: false };
      this.jsonTecnoSpeedAberto = true;
    },
    async copiarDadosTecnoSpeed() {
      if (!this.jsonTecnoSpeed.conteudo.trim()) {
        this.$toast.error("Esta NFSe não possui JSON de envio salvo.");
        return;
      }
      try {
        await this.$copyText(this.jsonTecnoSpeed.conteudo);
        this.$toast.success("JSON copiado!");
      } catch (error) {
        this.$toast.error("Não foi possível copiar o JSON.");
      }
    },
    async salvarJsonTecnoSpeed() {
      if (this.jsonTecnoSpeed.salvando) return;
      const { id_nfse, conteudo } = this.jsonTecnoSpeed;
      try {
        const documentos = JSON.parse(conteudo);
        if (
          !Array.isArray(documentos) ||
          !documentos.length ||
          documentos.some(
            (documento) =>
              !documento ||
              typeof documento !== "object" ||
              Array.isArray(documento)
          )
        ) {
          this.$toast.error(
            "O JSON deve conter uma lista de objetos de documentos da NFS-e."
          );
          return;
        }
      } catch (error) {
        this.$toast.error(
          "O JSON informado é inválido. Corrija antes de salvar."
        );
        return;
      }

      this.jsonTecnoSpeed.salvando = true;
      try {
        await this.$http.post("/nfse/salvar-json-tecnospeed", {
          id_nfse,
          data_tecnospeed: conteudo,
        });
      } catch (error) {
        const resposta = error.response?.data;
        const validacoes = resposta?.errors;
        this.$toast.error(
          validacoes?.data_tecnospeed?.[0] ||
            resposta?.message ||
            resposta?.msg ||
            "Não foi possível salvar o JSON da NFS-e."
        );
        return;
      } finally {
        this.jsonTecnoSpeed.salvando = false;
      }
      this.jsonTecnoSpeedAberto = false;
      this.$toast.success(
        "JSON salvo! As correções serão usadas na próxima transmissão."
      );
      this.$refs.nfselist.refresh();
    },
    async handleDeleteNFse({ id_nfse }) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir a NFSe " + id_nfse + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              this.$http.post("/nfse/delete", {
                id_nfse,
              });
              this.$toast.success("NFSe excluída com sucesso!");
              this.$refs.nfselist.refresh();
              this.actionsStore.updateTable = !this.actionsStore.updateTable;
            } catch (error) {
              console.log(error);
            }
          }
        });
    },
    shareToWhatsapp(data) {
      this.dataToWhatsapp = data;
      this.wppOpenModal = true;
    },
    async transmitirNFSes() {
      this.addLoadingToButton("transmitirNFSes");
      const nfseIds = this.actionsStore?.selectedRows.map((nfse) => ({
        id_nfse: nfse.id_nfse,
      }));

      if (nfseIds.length === 0) {
        this.$toast.error("NFSes sem ids válido!");
        this.removeLoadingToButton("transmitirNFSes");
        return;
      }
      try {
        await this.$http.post("/nfse/transmitir", {
          nfses: nfseIds,
        });
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("NFSe enviada com sucesso!");
        this.$refs.nfselist.refresh();
        this.$bvModal.hide("transmitirNFSesModal");
      } catch (error) {
        console.log(error);
      }

      this.removeLoadingToButton("transmitirNFSes");
    },
    async duplicar() {
      const id_nfse = this.actionsStore?.selectedRows[0]?.id_nfse;

      this.addLoadingToButton("doubleNFSe");
      if (!id_nfse) {
        this.$toast.error("NFSe sem id válido!");
        this.removeLoadingToButton("doubleNFSe");
        return;
      }
      try {
        await this.$http.post("/nfse/duplicar", {
          id_nfse,
        });
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("NFSe duplicada com sucesso!");
        this.$refs.nfselist.refresh();
        this.$bvModal.hide("duplicarNFSe");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("doubleNFSe");
    },
    async handleEditNFse({ id_nfse }) {
      swal({
        title: "Deseja editar a NFSe?",
        text: "Você ira ser direcionado para a pagina de edição aguarde...",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }

        await this.$http
          .post("/nfse/get-by-id", {
            id_nfse,
          })
          .then((response) => {
            swal.stopLoading();
            swal.close();
            this.$toast.info("Você será redirecionado agora");
            this.$router.push({
              name: "nova-nfseServicos",
              params: { nfseData: { ...response.data, id_nfse } },
            });
          })
          .catch(() => {
            swal.stopLoading();
            this.$toast.error("Erro ao solicitar o endpoint da NFSe");
            swal.close();
          });
      });
    },
    async handleCancelNFSe(data) {
      swal({
        title: "Deseja cancelar a NFSe?",
        text: "Informe o motivo do cancelamento!",
        icon: "info",
        content: "input",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }

        if (value.length < 15) {
          swal.stopLoading();
          this.$toast.warning(
            "O motivo tem que possuir no mínimo 15 caracteres"
          );
          swal.stopLoading();
          swal.close();
          return;
        }

        await this.$http
          .post("/nfse/cancelar", {
            id_nfse: data.id_nfse,
            motivo: value,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success(
              "Solicitação de cancelamento enviada com sucesso!"
            );
            this.$refs.nfselist.refresh();
            this.actionsStore.updateTable = !this.actionsStore.updateTable;
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    handleImprimirNFSe({ id_nfse }) {
      swal({
        title: "Deseja gerar o pdf da NFSe?",
        text: "Aguarde, pois será gerado o pdf automaticamente!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/nfse/imprimir", {
            id_nfse,
          })
          .then((result) => {
            const resultData = result["data"]["nfse_url"];
            if (resultData) {
              window.open(resultData, "_blank");
            }
            swal.stopLoading();
            swal.close();
            this.$toast.success("PDF gerado com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    async handleSendEmailNFSe(data) {
      swal({
        title: "Informe para quais e-mails deseja enviar a NFSe",
        text: "Separe diferentes email por vírgula",
        icon: "info",
        content: "input",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "Enviar",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }

        if (value.length === 0) {
          swal.stopLoading();
          this.$toast.warning("informe ao menos 1 email!");
          return;
        }

        const emails = value.replaceAll(" ", "").split(",");

        await this.$http
          .post("/nfse/email", {
            id_nfse: data.id_nfse,
            destinatarios: emails,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("NFSe enviada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    async handleConsultNFSe({ id_nfse }) {
      swal({
        title: "Deseja consultar a NFSe?",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "Sim",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        try {
          await this.$http.post("/nfse/consultar", {
            id_nfse,
          });
          this.$toast.success("NFSe consultada com sucesso!");
          swal.close();
          swal.stopLoading();
          this.actionsStore.updateTable = !this.actionsStore.updateTable;
        } catch (error) {
          swal.close();
          swal.stopLoading();
        }
      });
    },
    gerarlXml(data) {
      swal({
        title: "Deseja realizar a visualização do xml?",
        text: "Aguarde, pois será gerado o xml automaticamente!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/nfse/xml", {
            id_nfse: data.id_nfse,
          })
          .then((result) => {
            if (result["data"]["xml_url"]) {
              window.open(result["data"]["xml_url"], "_blank");
            }
            swal.stopLoading();
            swal.close();
            this.$toast.success("Xml gerado com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
  },
  computed: {
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {},
};
